import PropTypes from 'prop-types'
import MemberEventsLandingQuery, { MEMBER_EVENTS_LANDING_QUERY } from '@layouts/member-events-landing/member-events-landing.query'
import { fetchSSRData } from '@lib/ssr-fetch'

function MemberEventsLandingPage(props) {
  const { data: ssrData, ...restProps } = props
  return <MemberEventsLandingQuery {...restProps} ssrData={ssrData} />
}

MemberEventsLandingPage.propTypes = {
  data: PropTypes.object,
}

MemberEventsLandingPage.getInitialProps = async ({ query }) => fetchSSRData({
  query,
  graphqlQuery: MEMBER_EVENTS_LANDING_QUERY,
  variables: query,
  transform: (data) => data?.memberEventsLandingCollection?.items?.[0],
})

export default MemberEventsLandingPage
